module.exports = __webpack_public_path__ + "img/orange_067.9c3b2918.png";